import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TipoAnexo, TipoParentesco } from "app/model/solicitacaoAuxSaude";
import { SolicitacaoAuxSaudeService } from 'app/service/solicitacao-aux-saude/solicitacao-aux-saude.service';
import { ToastrService } from 'ngx-toastr';
import { ModalExcluirComponent } from '../modal-excluir/modal-excluir.component';
import { saveAs } from 'file-saver';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-modal-anexo',
  templateUrl: './modal-anexo.component.html',
  styleUrls: ['./modal-anexo.component.sass']
})
export class ModalAnexoComponent implements OnInit {

  listaTipoAnexos = []
  tipoAnexo: string = null;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['arquivo', 'acoes']
  pageSize: number = 5;
  totalElements: number = 0;
  arquivo: File;
  @ViewChild('fileInput') fileInput!: ElementRef;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private solicitacaoAuxSaudeService: SolicitacaoAuxSaudeService,
    private toasterService: ToastrService,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.carregarListaAnexos()

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  carregarListaAnexos() {
    this.solicitacaoAuxSaudeService.getListaAnexos(
      {
        id: this.data.id,
        isDependente: this.data.isDependente
      }
    ).subscribe((result) => {
      this.dataSource.data = result
      this.totalElements = result.length
      !this.data.visualizar && this.carregarListaTipoAnexos()
    }, (error) => {
      this.toasterService.error(error.error.message)
    })
  }

  carregarListaTipoAnexos() {
    this.solicitacaoAuxSaudeService.getTipoAnexo(
      {
        tipoParentesco: this.data.tipoParentesco,
        dataNascimento: this.data.dataNascimento ? this.trasnformarData(this.data.dataNascimento) : "",
        tipoPlano: this.data.tipoPlano,
        cpf: this.data.cpf
      }
    ).subscribe((result) => {
      //let tiposSemOutros: TipoAnexo[] = result.filter(item => item.descricao != "OUTROS")
      this.listaTipoAnexos = result.filter((item) => !this.dataSource.data.some((anexo) => {
        if(item.descricao !== "OUTROS"){
          return anexo.tipoAnexoId == item.id
        }
      }))
      this.dataSource.data.filter(item => {
        return item.descricao == "OUTROS";
      }).length > 2 && (this.listaTipoAnexos = this.listaTipoAnexos.filter(item => item.descricao != "OUTROS"))
    }, (error) => {
      this.toasterService.error(error.error.message)
    })
  }

  trasnformarData(data: Date): string {
    data = new Date(data);
    let dia = data.getDate().toString().padStart(2, '0');
    let mes = (data.getMonth() + 1).toString().padStart(2, '0'); // getMonth() é zero-indexado, então adicionamos 1
    let ano = data.getFullYear();
    return `${ano}/${mes}/${dia}`;
  }

  editar(id: number): void {

  }

  delete(id: number): void {
    this.solicitacaoAuxSaudeService.deletarAnexo(id).subscribe((result) => {
      this.toasterService.success("Anexo deletado com sucesso")
      this.carregarListaAnexos()
    }, (error) => {
      this.toasterService.error(error.error.message)
    })
  }

  getFormData(file: File): FormData {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('id', this.data.id);
    formData.append('dependente', this.data.isDependente);
    formData.append('tipoAnexo', this.tipoAnexo);
    return formData;
  }

  onArquivoSelecionado(event: any) {
    const allowedFileTypes = ['application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];
    if (file && allowedFileTypes.includes(file?.type) && file.size <= maxFileSizeInBytes) {
      this.arquivo = file;
      //this.enviarAnexoGrauInstrucao();
      this.solicitacaoAuxSaudeService.uploadAnexo(this.getFormData(this.arquivo)).subscribe((result) => {
        this.tipoAnexo = null;
        this.toasterService.success('Anexo enviado com sucesso');
        this.carregarListaAnexos();
        this.fileInput.nativeElement.value = '';
      },
        (error) => {
          this.toasterService.error(error.error.message)
        }
      )
    }
    else {
      this.arquivo = null;

      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos PDF são permitidos.');
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
      }
      //this.onArquivoExcluidoGrauInstrucao('erroForm')
    }
  }

  openDialogExcluir(anexo): void {
    this.dialog.open(ModalExcluirComponent, {
      width: '500px',
      data: {
        titulo: "Excluir Anexo",
        mensagem: `Deseja excluir o Anexo ${anexo.descricao}?`,
        botaoOk: "Sim",
        botaoCancelar: "Não",
        acaoOk: () => {
          //this.getFormData(null)
          this.delete(anexo.id)
        }
      }
    });
  }

  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toasterService.success('Arquivo baixado com sucesso');
  }

  downloadAnexo(anexo) {
    const data = {
      id: anexo.id,
      isDependente: this.data.isDependente
    }
    this.solicitacaoAuxSaudeService.getAnexo(data).subscribe((response: Blob) => {
      const fileName = `${anexo.descricao}.pdf`;
      const blob = new Blob([response], { type: 'application/octet-stream' });
      // Inicia o download do arquivo
      this.downloadFile(blob, fileName);
    })
  }

}
